<div (focus)="focus()" (focusout)="focusOut()" class="container-item-selector" tabindex="1" [ngClass]="{ blocked: loading }" [class.isInError]="isInError">
    <se-items-selector
        #tpl
        class="items-selector"
        name="items-selector"
        [disabled]="disabled"
        [class.focus]="focusElement"
        [class.disabled]="disabled"
        [emitItemsById]="emitItemsById"
        [autoSelectParent]="autoSelectParent"
        [filter]="filter"
        [inputSearchText]="inputSearchText"
        [itemList]="itemList"
        [noItemsSelectedMessage]="noItemsSelectedMessage"
        [selectedItems]="selectedItems"
        [status]="status"
        [title]="title"
        [visibleSelectAllButton]="visibleSelectAllButton"
        (filterChange)="filterChange.emit($event)"
        (loading)="onLoading($event)"
        (maxSelectableItemsNotify)="maxSelectableItems()"
        (notSelectableItemsNotify)="notSelectableItems()"
        (selectedItemsChange)="onItemSelectorSelectedItemsChange($event)"
        (statusChange)="changeStatus($event)"
        (isEmpty)="onIsEmptyChange($event)"
    >
    <ng-content extra-buttons-before select="[extra-buttons-before]"></ng-content>
</se-items-selector>
</div>
